import { addProperties } from './pdp-props.js';

const $doc = $(document);

var isLocal       = false;
var middlewareUrl = isLocal ?
                      'http://localhost/' :
                      'https://' + window.OsGlobals.domain + '/';

/**
 * Add cart item(s)
 * @return {Void}
 */ 

$doc.on("keydown", "form.product__form", function(event) { 
  return event.key != "Enter";
});

$doc.on('click', '.js-ajax-add', function(event) {
  event.preventDefault();

  const $this = $(this);  

  $this.addClass('is-loading');

  if(!window.variantCreated) {
    new Promise((resolve, reject) => {

      var productId = meta.product.id;
      var ndd_value = jQuery("#ndd_checkbox").is(":checked");

      if("undefined" != typeof oTags && "undefined" != typeof oTags.PRICE_TABLE_KEY) {

        var formData = $("form.form.product__form").serialize();
  
        var createVariantUrl = "https://"+window.OsGlobals.domain+"/makeVariant.js?"+formData+"&key="+oTags.PRICE_TABLE_KEY+"&width="+width+"&drop="+drop+"&parent="+productId+"&callback=newVariant";
        if(window.isVelux) {

          var createVariantUrl = middlewareUrl + "makeVariant.js?"
            + "&key=velux"
            + "&product_code="+window.velux.product_code
            + "&description=" + window.velux.description
            + "&make="+window.velux.make
            + "&colour="+window.velux.colour
            + "&size="+window.velux.size
            + "&parent="+productId
            + "&ndd_value="+ndd_value
            + "&callback=newVariant";

        } else {
    
          var width = $("#field-min-width").val();
          var drop = $("#field-min-drop").val();
        
          var units = $("input[name='radio-measurement']:checked").val();
        
          switch(units) {
            case "cm":
                width = width * 10;
                drop = drop * 10;
                break;
            case "inches":
                width = width * 25.4;
                drop = drop * 25.4;
                break;
          }

          var formData = $("form.form.product__form").serialize();
    
          var createVariantUrl = middlewareUrl + "makeVariant.js?"+formData+"&key="+oTags.PRICE_TABLE_KEY+"&width="+width+"&drop="+drop+"&parent="+productId+"&callback=newVariant&ndd_value="+ndd_value;
        }
        console.log(createVariantUrl);
    
        let loadScript = document.createElement("script");
    
        loadScript.onload = resolve;
        loadScript.onerror = reject;
    
        loadScript.async = true;
        loadScript.src = createVariantUrl;
        document.getElementsByTagName("head")[0].appendChild(loadScript);
      }
    });

    return false;
  }


  addProperties();

  

  /*
  const id = $this
    .closest('form')
    .find('select[name="id"]')
    .val();
  //*/

  const id = window.variantId;

  const quantity = $this
    .closest('form')
    .find('input[name="quantity"]')
    .val();

  const propsSlat = $this
    .closest('form')
    .find('#slat-props')
    .val().split(' | ').join(' ');

  const propsSizes = $this
    .closest('form')
    .find('#sizes-props')
    .val().split(' | ').join(' ');

  const propsControl = $this
    .closest('form')
    .find('#control-props')
    .val().split(' | ').join(' ');

  const propsOptions = $this
    .closest('form')
    .find('#options-props')
    .val().split(' | ').join(' ');

  const properties = {
    "Slat": propsSlat,
    "Sizes": propsSizes,
    "Controls": propsControl,
    "Options": propsOptions
  }

  const items = [{ id, quantity, properties: properties }];

  console.log(items);

  Cart.add(items, "js-ajax-add");

  //$('.btn-cart').trigger('click');

  $('html, body').animate({
    scrollTop: 0
  }, 600);
});

/**
 * Remove item
 * @return {Void}
 */

$doc.on('click', '.js-line-item-remove', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this.data('key');
  const isCartItem = $this.closest('.js-cart-item').length;
  let isCartPage = isCartItem ? true : false;

  Cart.updateItem(0, id, null, isCartPage);
});

/**
 * Add Sample to cart item(s)
 * @return {Void}
 */

$doc.on('click', '.js-add-sample', function(event) {
  event.preventDefault();

  const $this = $(this);
  const id = $this
    .closest('form')
    .find('select[name="id"] [data-sample]')
    .val();
  const quantity = 1;
  const items = [{ id, quantity }];

  $this.prop('disabled', true);

  $this.addClass('is-loading');

  Cart.add(items, "js-ajax-sample");
});
